// Helpers for the /bank/account/information/v3 payload.
//
// Kept free of React so they can be unit tested rather than only exercised by rendering.

/**
 * Display mask for a holder's document.
 *
 * Dominican cedulas are 11 digits and RNCs are 9. Formatting an RNC with the cedula mask
 * silently drops digits, which would print a wrong number on a payment screen, so the
 * mask follows the digit count rather than the declared type.
 */
export const docMask = (value) =>
  String(value ?? "").replace(/\D/g, "").length === 9 ? "###-#####-#" : "###-#######-#";

/**
 * Label for the document, falling back to a neutral word rather than guessing wrong.
 */
export const docLabel = (account) => account?.OWNER_DOC_TYPE || "Documento";
